import { IStringDate } from '~/utils/stringDate/types';

export const startOfQuarter = (date: IStringDate): IStringDate => {
  const year = date.split('-')[0];
  const month = date.split('-')[1];
  const quarter = Math.floor(Number(month) / 3) + 1;
  return `${year}-${quarter}-01`;
};
